import { IProcesedHouse } from "@/store/island/interfaces";

export const isCanUpgrade = (house: IProcesedHouse | undefined) => {
    if(!house) return false;
    return house.level === house.max_level;
};
